import { Option } from 'constants/models'

import { createTypeFromEnumValues } from 'utils/typescript'

import i18n from 'translations'

export type AdministrationStatusProps = Option<createTypeFromEnumValues<ADMINISTRATION_STATUSES>>
export type AdministerTypeProps = Option<createTypeFromEnumValues<ADMINISTRATION_TYPE>>

export enum ADMINISTRATION_STATUSES {
  ADMINISTERED = 'administered',
  MISSED = 'missed',
  SCHEDULED = 'scheduled',
  SIGNED = 'signed',
}

export const ADMINISTRATION_STATUS_LABELS = {
  [ADMINISTRATION_STATUSES.ADMINISTERED]: i18n.t('services:Administration:AdministrationStatus:administered'),
  [ADMINISTRATION_STATUSES.MISSED]: i18n.t('services:Administration:AdministrationStatus:missed'),
  [ADMINISTRATION_STATUSES.SCHEDULED]: i18n.t('services:Administration:AdministrationStatus:scheduled'),
  [ADMINISTRATION_STATUSES.SIGNED]: i18n.t('services:Administration:AdministrationStatus:signed'),
}

export const ADMINISTRATION_STATUS_OPTIONS = [
  {
    label: ADMINISTRATION_STATUS_LABELS[ADMINISTRATION_STATUSES.ADMINISTERED],
    value: ADMINISTRATION_STATUSES.ADMINISTERED,
  },
  {
    label: ADMINISTRATION_STATUS_LABELS[ADMINISTRATION_STATUSES.SCHEDULED],
    value: ADMINISTRATION_STATUSES.SCHEDULED,
  },
  {
    label: ADMINISTRATION_STATUS_LABELS[ADMINISTRATION_STATUSES.SIGNED],
    value: ADMINISTRATION_STATUSES.SIGNED,
  },
  {
    label: ADMINISTRATION_STATUS_LABELS[ADMINISTRATION_STATUSES.MISSED],
    value: ADMINISTRATION_STATUSES.MISSED,
  },
]

export enum ADMINISTRATION_TYPE {
  EMERGENCY = 'emergency',
  SCHEDULED = 'scheduled',
}

export const ADMINISTRATION_TYPE_LABELS = {
  [ADMINISTRATION_TYPE.SCHEDULED]: i18n.t('services:Administration:AdministrationType:scheduled'),
  [ADMINISTRATION_TYPE.EMERGENCY]: i18n.t('services:Administration:AdministrationType:emergency'),
}

export const ADMINISTRATION_TYPE_OPTIONS = [
  {
    label: ADMINISTRATION_TYPE_LABELS[ADMINISTRATION_TYPE.SCHEDULED],
    value: ADMINISTRATION_TYPE.SCHEDULED,
  },
  {
    label: ADMINISTRATION_TYPE_LABELS[ADMINISTRATION_TYPE.EMERGENCY],
    value: ADMINISTRATION_TYPE.EMERGENCY,
  },
]
